export default {
  isLoading: false,
  specializations: null,
  zeroRegistrySpecializations: null,
  reallyAllSpecializations: null,
  specialization: null,
  addresses: null,
  organizations: null,
  services: null,
  skills: null,
  testingIndicators: null,
  testingRoles: null,
  materialTypes: null,
  targetTypes: null,
  scales: null,
  errors: null,
};
